/**
 *  @class
 *  @function FreeShipping — 3-tier discount progress bar (item count based)
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.count  = parseInt(this.dataset.itemCount, 10) || 0;
      this.t1     = parseInt(this.dataset.t1, 10);
      this.t2     = parseInt(this.dataset.t2, 10);
      this.t3     = parseInt(this.dataset.t3, 10);
      this.labels = [this.dataset.t1Label, this.dataset.t2Label, this.dataset.t3Label];
      this.statusEl = this.querySelector('.free-shipping--status');
      this.dots     = this.querySelectorAll('.free-shipping--milestone');
      this._render();
    }

    _render() {
      const { count, t1, t2, t3, labels } = this;
      let pct = 0;

      if (count >= t3) {
        pct = 1;
        this._dot(0, 'complete'); this._dot(1, 'complete'); this._dot(2, 'complete');
        if (this.statusEl) this.statusEl.innerHTML = this._maxText();
      } else if (count >= t2) {
        pct = 2/3 + ((count - t2) / (t3 - t2)) * (1/3);
        this._dot(0, 'complete'); this._dot(1, 'complete'); this._dot(2, 'active');
        if (this.statusEl) this.statusEl.innerHTML = this._addMoreText(t3 - count, labels[2]);
      } else if (count >= t1) {
        pct = 1/3 + ((count - t1) / (t2 - t1)) * (1/3);
        this._dot(0, 'complete'); this._dot(1, 'active'); this._dot(2, 'none');
        if (this.statusEl) this.statusEl.innerHTML = this._addMoreText(t2 - count, labels[1]);
      } else {
        pct = t1 > 0 ? (count / t1) * (1/3) : 0;
        this._dot(0, 'active'); this._dot(1, 'none'); this._dot(2, 'none');
        if (this.statusEl) this.statusEl.innerHTML = this._addMoreText(t1 - count, labels[0]);
      }

      this.style.setProperty('--percentage', Math.min(pct, 1));
    }

    _addMoreText(remaining, label) {
      const tpl = (window.theme.strings && window.theme.strings.discountBarAddMore)
        || 'COUNT_PLACEHOLDER ürün daha ekle → LABEL_PLACEHOLDER';
      return tpl.replace('COUNT_PLACEHOLDER', remaining).replace('LABEL_PLACEHOLDER', label);
    }

    _maxText() {
      return (window.theme.strings && window.theme.strings.discountBarMaxUnlocked)
        || 'Maksimum indirim kazanıldı!';
    }

    _dot(index, state) {
      const dot = this.dots[index];
      if (!dot) return;
      dot.classList.remove('is-complete', 'is-active');
      const ck    = dot.querySelector('.free-shipping--checkmark');
      const inner = dot.querySelector('.free-shipping--milestone-dot');
      if (state === 'complete') {
        dot.classList.add('is-complete');
        if (!ck && inner) inner.innerHTML = '<span class="free-shipping--checkmark">✓</span>';
      } else if (state === 'active') {
        dot.classList.add('is-active');
        if (ck) ck.remove();
      } else {
        if (ck) ck.remove();
      }
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
